<template>
  <div v-if="(elType == 'task' || elType == 'macro') && (elStartTime || elEndTime)">
    <table class="w-100 small">
      <tbody>
        <tr>
          <td v-if="elStartTime" class="nobr" style="padding-right: 2px">
            <i v-if="elIsLocked" class="small far fa-lock" style="position: relative; top: -1px"></i>
            {{ $filters.moment(elStartTime, 'mediumDateNoYear', planningLocale) }}
            <span v-if="elSchedule.start" style="color: rgba(0,0,0,0.65);">{{ $filters.moment(elSchedule.start, 'LT', planningLocale) }}</span>
          </td>
          <td v-if="elEndTime" :class="elEndTimeColorClass" class="nobr float-right">
            <i v-if="elIsLocked" class="small far fa-lock" style="position: relative; top: -1px"></i>
            {{ $filters.moment(elEndTime, 'mediumDateNoYear', planningLocale) }}
            <span v-if="elSchedule.end" style="color: rgba(0,0,0,0.65);">{{ $filters.moment(elSchedule.end, 'LT', planningLocale) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else-if="elType == 'milestone' && elStartTime" class="date">
    <div :class="elEndTimeColorClass">
      <i v-if="elIsLocked" class="small far fa-lock" style="position: relative; top: -1px"></i>
      {{ $filters.moment(elStartTime, 'mediumDateNoYear', planningLocale) }}
    </div>
    <div v-if="elSchedule.start || elSchedule.end" class="small" style="font-weight: normal;">
      <span v-if="elSchedule.start">{{ $filters.moment(elSchedule.start, 'LT', planningLocale) }}</span>
      <span v-else>...</span>
      <span v-if="elSchedule.end">- {{ $filters.moment(elSchedule.end, 'LT', planningLocale) }}</span>
    </div>
  </div>
</template>

<style>
  .element.milestone .date {
    font-weight: bold;
    color: rgb(var(--v-theme-darkgrey));
  }
</style>

<script>
  import useUiPlanningStore from '@/stores/ui/planning';

  export default {
    props: {
      planning: { type: Object, required: true },
      el: { type: Object, required: true },
    },
    data() {
      return {
        uiPlanningStore: useUiPlanningStore(),
      };
    },
    computed: {
      elType() {
        return this.el.getType();
      },
      elStartTime() {
        return this.el.getStartTime();
      },
      elEndTime() {
        return this.el.getEndTime();
      },
      elEndTimeColorClass() {
        const isKanbanMode = this.uiPlanningStore.mode == 'kanban';
        return isKanbanMode && this.el.getEndTimeColorClass() || null;
      },
      elSchedule() {
        return this.el.getSchedule();
      },
      elIsLocked() {
        return this.el.getIsLocked();
      },
      planningLocale() {
        return this.planning.timeline.getTimelocale();
      },
    },
  };
</script>
